export default __webpack_public_path__ + "static/media/img.325dc8dc.png";